// ==============================|| OVERRIDES - TYPOGRAPHY ||============================== //

export default function Typography() {
  return {
    MuiTypography: {
      styleOverrides: {
        gutterBottom: {
          marginBottom: 12
        }
      },
      defaultProps: { variantMapping: { title: 'h2', subtitle: 'p', subtitle3: 'p' } }
    }
  };
}
